export interface ApiError {
  error: string;
  message: string;
}

async function request<T>(method: string, path: string, body?: unknown, token?: string): Promise<T> {
  const res = await fetch(path, {
    method,
    headers: {
      'content-type': 'application/json',
      ...(token ? { authorization: `Bearer ${token}` } : {}),
    },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const data = (await res.json().catch(() => null)) as (T & Partial<ApiError>) | null;
  if (!res.ok) throw new Error(data?.message ?? 'Der Server ist nicht erreichbar.');
  return data as T;
}

export interface LobbyLinks {
  host: string;
  join: string;
  overlay: string;
}

export const api = {
  createLobby: (password: string, lobbyPassword: string) =>
    request<{ code: string; hostToken: string; links: LobbyLinks }>('POST', '/api/lobbies', {
      password,
      lobbyPassword,
    }),
  lobbyInfo: (code: string) =>
    request<{
      code: string;
      phase: string;
      open: boolean;
      players: number;
      maxPlayers: number;
      passwordRequired: boolean;
    }>('GET', `/api/lobbies/${code}`),
  join: (code: string, name: string, cameraUrl: string | null, lobbyPassword: string) =>
    request<{ playerId: string; token: string }>('POST', `/api/lobbies/${code}/join`, {
      name,
      cameraUrl,
      lobbyPassword,
    }),
};
